import { render, staticRenderFns } from "./peopleInOut.vue?vue&type=template&id=8fd3f3e0&scoped=true"
import script from "./peopleInOut.vue?vue&type=script&lang=js"
export * from "./peopleInOut.vue?vue&type=script&lang=js"
import style0 from "./peopleInOut.vue?vue&type=style&index=0&id=8fd3f3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd3f3e0",
  null
  
)

export default component.exports